import React from 'react';

export function NumberedListField({ field, value, onChange }) {
  const items = value && value.length === field.count ? value : Array.from({ length: field.count }, (_, i) => (value && value[i]) || '');

  const update = (idx, text) => {
    const next = items.slice();
    next[idx] = text;
    onChange(next);
  };

  return (
    <ol className="rb-numbered-list">
      {items.map((item, idx) => (
        <li key={idx}>
          <input
            className="rb-list-input"
            type="text"
            value={item}
            onChange={(e) => update(idx, e.target.value)}
            placeholder={`Item ${idx + 1}`}
          />
        </li>
      ))}
    </ol>
  );
}

export function SignoffField({ field, value, onChange }) {
  const rows = field.rows;
  const data = value && value.length ? value : rows.map(() => ({ name: '', date: '' }));

  const update = (idx, patch) => {
    const next = data.map((r, i) => (i === idx ? { ...r, ...patch } : r));
    onChange(next);
  };

  return (
    <div className="rb-signoff">
      {rows.map((label, idx) => (
        <div className="rb-signoff-row" key={idx}>
          <span className="rb-signoff-label">{label}</span>
          <input
            className="rb-signoff-input"
            type="text"
            placeholder="Name & title"
            value={data[idx]?.name || ''}
            onChange={(e) => update(idx, { name: e.target.value })}
          />
          <input
            className="rb-signoff-input rb-signoff-date"
            type="text"
            placeholder="Date"
            value={data[idx]?.date || ''}
            onChange={(e) => update(idx, { date: e.target.value })}
          />
        </div>
      ))}
    </div>
  );
}

export function InfoBox({ field }) {
  return (
    <div className="rb-infobox">
      <p className="rb-infobox-title">{field.title}</p>
      <p className="rb-infobox-body">{field.body}</p>
    </div>
  );
}
